import i18n from "../../../constants/i18n";
import { getPermissionIDRequired } from "../../../helpers/et3-has-permission";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import HeaderMenuItem from "../HeaderMenuItem";
import { getKhattabatAssignStore } from "../../../stores/khattabat-stores/assign-store";

const KhattabaMenu = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const totalUnassignedNewClients =
    getKhattabatAssignStore().getTotalUnassignedNewClientsAndTesters.get();
  const totalMaleUnreadMessages =
    getDashBoardStore().totalMaleUnreadMessages.get();
  const totalFemaleUnreadMessages =
    getDashBoardStore().totalFemaleUnreadMessages.get();
  const adminIsUnderMaintenance =
    getCorePersonalStore().adminUnderMaintenance.get();

  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1270}
      height={95}
      fDirection="row"
      alignItems="center"
      justifyContent={isKhattabaAiAdmin ? "space-around" : "space-between"}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {isKhattabaAiAdmin ? null : (
        <HeaderMenuItem
          isSelected={
            getCoreHistoryStore().getPageName() === "KHATTABAT_NEW_CLIENTS"
          }
          size="MEDIUM"
          text={i18n.get("NEW_CLIENTS")}
          counter={`${totalUnassignedNewClients}`}
          link="/khattabat/newClients"
          enabled={
            userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
            !adminIsUnderMaintenance
          }
        />
      )}
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "KHATTABAT_M"}
        size="MEDIUM"
        text={i18n.get("MALE_CLIENTS")}
        counter={`${totalMaleUnreadMessages}`}
        link="/khattabat/Male"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      <HeaderMenuItem
        isSelected={getCoreHistoryStore().getPageName() === "KHATTABAT_F"}
        size="MEDIUM"
        text={i18n.get("FEMALE_CLIENTS")}
        counter={`${totalFemaleUnreadMessages}`}
        link="/khattabat/Female"
        enabled={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          !adminIsUnderMaintenance
        }
      />
      {isKhattabaAiAdmin ? null : (
        <HeaderMenuItem
          isSelected={
            getCoreHistoryStore().getPageName() === "KHATTABAT_MATCHING_RESULTS"
          }
          size="MEDIUM"
          text={i18n.get("KHATTABAT_MATCHING_RESULTS")}
          counter={`${0}`}
          link="/khattabatMatching/results"
          enabled={
            userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
            !adminIsUnderMaintenance
          }
        />
      )}
    </ET3Div>
  );
});

export default KhattabaMenu;
